import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <a href="/impressum" className="footer-link">Impressum</a>
      </div>
    </footer>
  );
}

export default Footer;
